import React from 'react'

import { InformationCard } from '@frame/ui-components/information-card'
import { UnorderedList } from '@frame/ui-components/unordered-list'
import { P } from '@frame/ui-primitives/p'
import { Span } from '@frame/ui-primitives/span'

import { getW2Year } from '../../../utils/getW2Year'

export function W2Info() {
  const { currentYear, w2Year } = getW2Year()

  return (
    <InformationCard>
      <P className="text-sm">
        <Span className="font-bold">What is a W2?</Span> A document that shows your total yearly earnings and taxes
        paid. You'll use it when it's time to file your taxes.
      </P>
      <UnorderedList
        className="text-sm"
        title="It includes:"
        items={[
          `"W2" and ${w2Year} at the top`,
          'Your name and address',
          'Employer info',
          'Sections with earnings and taxes paid',
        ]}
      />
      <P className="text-sm">
        <Span className="font-bold">Where can I find mine?</Span> Your employer usually provides it by mail or online by
        the end of January {currentYear}.
      </P>
    </InformationCard>
  )
}
